<template lang="pug">
.quotations(:class="{ 'darkTheme__quotations': isDarkTheme && !isPartner }")
    cp-header(:partner="hasPartnerA2G")

    cp-partner-logo(
      v-if="appSettings.partner"
      :name="appSettings.partner.name"
      :logo="appSettings.partner.logo"
    )

    cp-quotation-inline(@appearQuotation='changeAppearInfosQuotation')

    .quotations__container(v-if="!asyncPending && appearInfosQuotation")
      template(v-if="!hasNational")
        .quotations__container--warning(v-if="appearWarning && covidCoverage !== 'not_include' && !Number(planCovidSelected)")
          svg(name="icon-error" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none")
            path(fill-rule="evenodd" clip-rule="evenodd" d="M21.5 11C21.5 5.20101 16.799 0.5 11 0.5C5.20101 0.5 0.5 5.20101 0.5 11C0.5 16.799 5.20101 21.5 11 21.5C16.799 21.5 21.5 16.799 21.5 11ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11ZM11 5.83333C11.3846 5.83333 11.7016 6.12286 11.745 6.49587L11.75 6.58333V13.3333C11.75 13.7475 11.4142 14.0833 11 14.0833C10.6154 14.0833 10.2984 13.7938 10.255 13.4208L10.25 13.3333V6.58333C10.25 6.16912 10.5858 5.83333 11 5.83333ZM11 17.0833C11.4142 17.0833 11.75 16.7475 11.75 16.3333C11.75 15.9191 11.4142 15.5833 11 15.5833C10.5858 15.5833 10.25 15.9191 10.25 16.3333C10.25 16.7475 10.5858 17.0833 11 17.0833Z" fill="#DF2E24")
          span Você não selecionou o valor para a cobertura Covid-19. Por favor, escolha o valor desejado.

        .quotations__container__ruler(v-if="(destinationId !== 'Y15') && (destinationId !== 'Y30') && (showCovidSelector)")
          h2.quotations__container__ruler__title Seu Seguro Viagem tem cobertura para Covid-19
          p.quotations__container__ruler__description Recomendamos a partir de {{ isNationalDestination }} 30.000, selecione a sua:

          .quotations__container__ruler__select
            .quotations__container__ruler__select__input(@click="openBoxCoversCovid")
              span.quotations__container__ruler__select__text(v-if="!planCovidSelected") Selecione
              span.quotations__container__ruler__select__text(v-else) {{ labelSelectCovidCover }}
            ol.quotations__container__ruler__coversValue(:class="[{ 'isOpen' : isOpenBoxCovers }, `quotations__container__ruler__coversValue--${insurer}`]")
              li.quotations__container__ruler__coversValue__item(
                v-for="(plan, key) in covidCovers"
                v-if="plan.id !== 0"
                :id="plan.id"
                :class="[{'active': planCovidSelected == plan.id, 'disabled': isDisabledCoverageSelecteds, 'recomended': plan.hasRecommended }]"
                @click="changePlanCovid(plan)"
              ) {{ isNationalDestination }} {{ plan.value}}
                span.quotations__container__ruler__coversValue__extraLabel(v-if="plan.extraLabel") {{ plan.extraLabel }}

      .quotations__container__content
        .quotations__container__content__title
          h2.quotations__container__content__title--text Escolha o plano
          span.quotations__container__content__title--description {{ lblDescription }} #[br]
          span.quotations__container__content__title--description.quotations__container__content__title--warning Para validade do Seguro Viagem, a contratação deve ser realizada #[u antes] do embarque no Brasil. Se você já está em viagem e deseja renovar o seguro, entre em contato com os nossos canais de atendimento para a compra.
        .quotations__container__content__quotationCoupon(v-if="appSettings.promoCode.enable")
          cp-quotation-coupon

    .loader(v-if="asyncPending")
      cp-loader(text="Estamos buscando as melhores opções")
    cp-table-quotation(
      v-else
      :covidCoverage="covidCoverage"
      :covidCoverageLabel="labelSelectCovidCover"
      @appearWarning='changeAppearWarning'
      @openModal="openModal"
    )

    modal-base(
      v-if="isToggleModal"
      :id="loadComponentInModal.id"
      :class="loadComponentInModal.class"
      :position="loadComponentInModal.position"
      :isCloseVisible="loadComponentInModal.isCloseVisible"
      @toggle="toggleModal"
    )
      component(:is="loadComponentInModal.component" @toggle="toggleModal")

    cb-footer(
      v-if="!hasPartnerA2G"
      product="trip"
      :hideLinks="showLivelo ? [] : ['pontos-livelo']"
      INSTITUCIONAL_URL="https://www.ciclic.com.br"
    )
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import cpHeader from '@/components/ui/Header'
import cpPartnerLogo from '@/components/PartnerLogo'
import cpLoader from '@/components/Loader'
import cpQuotationInline from '@/components/QuotationInline'
import cpTableQuotation from '@/components/TableQuotation'
import cpQuotationCoupon from '@/components/ui/QuotationCoupon.vue'
import cpRulerCovidCover from '@/components/RulerCovidCover.vue'
import ModalBase from '@/components/ModalBase'
import ExpiredPromoCodeModalContent from '@/components/ExpiredPromoCodeModalContent'
import ChipModal from '@/components/ChipModal/index.vue'

export default {
  head: {
    title: {
      inner: 'Resultado da simulação - Seguro viagem'
    }
  },
  mounted () {
    this.clearSession()
    this.changeAppearWarningInMultripQuotation()
    this.covidCoverage = Number(this.planCovidSelected) === 0 ? 'not_include' : 'include'
  },
  data () {
    return {
      isDarkTheme: false,
      covidCoverage: 'include',
      appearWarning: false,
      appearInfosQuotation: true,
      isToggleModal: false,
      loadComponentInModal: null,
      templatesForModal: {
        ExpiredPromoCodeModalContent: {
          component: 'ExpiredPromoCodeModalContent',
          id: 'expired-promocode-modal',
          class: 'expired-promocode-modal',
          position: 'right',
          isCloseVisible: false
        },
        ChipModal: {
          component: 'ChipModal',
          position: 'right',
          isCloseVisible: true
        }
      },
      showCovidSelector: false
    }
  },
  components: {
    cpHeader,
    cpPartnerLogo,
    cpLoader,
    cpQuotationInline,
    cpTableQuotation,
    cpQuotationCoupon,
    cpRulerCovidCover,
    ModalBase,
    ExpiredPromoCodeModalContent,
    ChipModal
  },
  watch: {
    destinationId () {
      this.changeAppearWarningInMultripQuotation()
    }
  },
  computed: {
    ...mapState('travelSetup', ['appSettings', 'theme']),
    ...mapState('quotation', [
      'asyncPending',
      'destinationId',
      'planCovidSelected',
      'insurer',
      'hasNational'
    ]),
    ...mapGetters('quotation', ['covidCovers', 'showLivelo']),
    isDisabledCoverageSelecteds () {
      return this.covidCoverage === 'not_include'
    },
    lblDescription () {
      return this.$partnerBB
        ? 'Condições exclusicas para clientes Banco do Brasil'
        : 'Compare e selecione o melhor plano para você.'
    },
    hasPartnerA2G () {
      return this.theme === 'a2g'
    },
    isPartner () {
      return this.hasPartnerA2G || this.$partnerBB
    },
    isNationalDestination () {
      return this.destinationId === 'BR' ? 'R$' : 'USD'
    },
    isResponsive () {
      return window.innerWidth <= 1110
    },
    labelSelectCovidCover () {
      if (this.covidCovers.length === 0) return false

      return +this.planCovidSelected === 0
        ? this.covidCovers.find((obj) => obj.id === Number(this.planCovidSelected)).value
        : `${this.isNationalDestination} ${this.covidCovers.find((obj) => obj.id === Number(this.planCovidSelected)).value}`
    }
  },
  methods: {
    ...mapMutations('quotation', ['setPromoCode']),
    changeAppearWarningInMultripQuotation () {
      if (this.destinationId === 'Y15' || this.destinationId === 'Y30') {
        this.covidCoverage = 'not_include'
        this.appearWarning = false
      }
    },
    changeAppearInfosQuotation (value) {
      this.appearInfosQuotation = value
    },
    backToSimulation () {
      this.$router.push('/')
    },
    changeAppearWarning (value) {
      if (value) window.scrollTo(0, 0)
      this.appearWarning = value
    },
    clickingTracking () {
      window.dataLayer.push({
        event: 'viagem-ciclic',
        categoria: 'viagem-cotacao',
        acao: 'cobertura-covid',
        rotulo: this.planCovidSelected
      })
    },
    applyPlanCovid () {
      let query = Object.assign({}, this.$route.query)

      query.planCovidSelected = this.inputPlanCovid
      this.$router.replace({ query })
    },
    clearSession () {
      sessionStorage.removeItem('ciclic:travel')
    },
    openModal (componentName) {
      this.loadComponentInModal = this.templatesForModal[componentName]
      this.toggleModal()
    },
    toggleModal () {
      this.isToggleModal = !this.isToggleModal

      if (this.loadComponentInModal.component === 'ExpiredPromoCodeModalContent') {
        const query = { ...this.$route.query }
        delete query.promo_code
        this.setPromoCode('')
        this.$router.replace({ query })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/style/ui/variables";
@import "~@/style/components/dark-theme";

.maintenance {
  align-items: center;
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  margin: 40px auto;
  max-width: 1280px;
  min-height: calc(100vh - 514px);
  padding: 0 16px;

  @media screen and (min-width: 1173px) {
    margin-bottom: 72px;
    margin-top: 72px;
  }

  &__wrapper {
    max-width: 792px;
  }

   &__title {
     color: #444;
    font-size: 28px;

    @media screen and (min-width: 768px) {
      font-size: 46px;
      line-height: 64px;
    }

    @media screen and (min-width: 1173px) {
      font-size: 56px;
    }
  }

  &__text {
    font-size: 16px;
    line-height: 24px;
    max-width: 671px;

    @media screen and (min-width: 768px) {
      font-size: 20px;
    }
  }

  &__btn {
    border: 1px solid #D5D5D7;
    border-radius: 28px;
    color: #373739;
    display: block;
    font-size: 18px;
    margin-top: 40px;
    max-width: 256px;
    padding: 12px 57px;

    @media screen and (max-width: 1173px) {
      margin-bottom: 20px;
    }
  }
}

.toolbar-quotation {
  align-items: center;
  background-color: $white;
  display: flex;
  justify-content: center;
  min-height: 76px;
  position: relative;
  width: 100%;
  user-select: none;

  @media screen and (max-width: 900px) {
    box-shadow: none;
    min-height: 52px;
  }

  &.shadow {
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.1);
    z-index: 1;
  }

  & > & {
    padding: 8px 16px 16px 16px;
  }
}

.radio {
  position: relative;
  display: inline-block;
  cursor: pointer;
  line-height: 20px;
  font-size: 14px;
  margin-right: 30px;

  .label {
    position: relative;
    display: block;
    float: left;
    margin-right: 10px;
    width: 20px;
    height: 20px;
    border: 2px solid $color-silver-sand;
    border-radius: 100%;
    -webkit-tap-highlight-color: transparent;

    &:after {
      content: '';
      position: absolute;
      top: 3px;
      left: 3px;
      width: 10px;
      height: 10px;
      border-radius: 100%;
      background: $color-purple-heart;
      transform: scale(0);
      transition: all .2s ease;
      opacity: .08;
      pointer-events: none;
    }
  }
  &:hover {
    .label:after {
      transform: scale(3.6);
    }
  }
}

input[type="radio"]:checked + .label {
  border-color: $color-purple-heart;

  &:after {
    transform: scale(1);
    transition: all .2s cubic-bezier(.35, .9, .4, .9);
    opacity: 1;
  }
}

.hidden {
  display: none;
}

.quotations {
  background-color: #f0f4f9;
  color: $color-tundora;
  font-family: $oscine-font-family;
  min-height: 100vh;

  .themeBB & {
    color: #0038a8;
  }

  &__container {
    width: 100%;
    max-width: 1281px;
    margin: 44px auto;
    padding-left: 16px;
    padding-right: 16px;

    &-overflow {
      margin: 32px 32px -12px;
    }

    &--warning {
      background: #FDDFDF;
      border: 1px solid #DF2E24;
      border-radius: 8px;
      display: flex;
      padding: 14px 26px;
      margin-bottom: 30px;

      > span {
        font-size: 14px;
        font-weight: 600;
        color: #444;
        margin-left: 16px;
      }
    }

    @media screen and (min-width: 1279px) {
      padding-left: 32px;
      padding-right: 32px;
    }

    @media screen and (min-width: 1279px) {
      padding-left: 0;
      padding-right: 0;
    }

    &__content {
      display: flex;
      justify-content: space-between;

      @media screen and (max-width: 767px) {
        flex-direction: column;
        align-items: flex-start;
      }

      &__title {
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        margin-right: 20px;
        max-width: 660px;
        width: 100%;

        &--text {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 8px;

          @media screen and (min-width: 426px) {
            font-size: 32px;
          }
        }

        &--description {
          color: $color-scorpion;
          font-family: $rubik-font-family;
          font-size: 16px;
          font-weight: normal;
          line-height: 1.32;

          .themeBB & {
            color: #0038a8;
          }
        }

        &--warning {
          font-size: 12px;
        }
      }

      &__quotationCoupon {
        width: 100%;
        max-width: 418px;

        @media screen and (max-width: 767px) {
          margin-top: 32px;
        }
      }
    }
  }
}

.partnerLogo{
  text-align: center;
  margin-top: 30px;
  img{
    height: 70px;
    max-width: 100%;
  }
}
</style>
